import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React from 'react';
import { useState, useEffect } from 'react';
import { Col, Form, Card, Table, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ClaimGroupUserAccessForm from './ClaimGroupUserAccessForm';
import UserProjectAccess from './UserProjectAccess';
import UnitsAndProjectsUserAccessesList from './UnitsAndProjectsUserAccessesList';
const EditUserAccessModal = _ref => {
  let {
    show,
    title,
    onHide,
    onSubmit,
    userAccess,
    company,
    claimGroup,
    setClaimGroup
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [clientContact, setClientContact] = useState({
    ...userAccess
  });
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setClientContact({
      ...userAccess
    });
  }, [userAccess]);
  const clientContactModalBody = () => {
    return /*#__PURE__*/React.createElement(Card, {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(ClaimGroupUserAccessForm, {
      clientContact: clientContact,
      setClientContact: setClientContact
    })), /*#__PURE__*/React.createElement(Col, {
      md: 9
    }, /*#__PURE__*/React.createElement(Row, {
      className: "mb-5"
    }, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, /*#__PURE__*/React.createElement(UserProjectAccess, {
      userAccess: userAccess,
      company: company,
      claimGroup: claimGroup,
      setClaimGroup: setClaimGroup,
      loading: loading,
      setLoading: setLoading
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 12
    }, /*#__PURE__*/React.createElement(UnitsAndProjectsUserAccessesList, {
      userAccess: userAccess,
      setLoading: setLoading,
      claimGroup: claimGroup,
      setClaimGroup: setClaimGroup,
      loading: loading
    })))))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: t(title),
    show: show,
    renderBody: () => clientContactModalBody(),
    onHide: onHide,
    onSubmit: () => onSubmit(clientContact)
  }));
};
export default EditUserAccessModal;